import { NavLink } from 'react-router'
import { Container, Reveal, RevealGroup } from '@/components/common'
import { partnershipOptions } from '@/constants/partnership'
import { ROUTES } from '@/constants/routes'

export const PartnershipOptions = () => {
  return (
    <section className="bg-surface py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Many ways to <span className="text-ibon-dark/30">work with us.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-6 text-lg leading-relaxed text-text-muted">
              Whether through sponsorship, knowledge exchange, volunteering, or strategic
              collaboration, your support helps us expand our reach and deepen our impact.
            </p>
          </Reveal>
        </div>

        <RevealGroup
          className="mt-16 grid gap-px overflow-hidden border border-border bg-border sm:grid-cols-2 lg:grid-cols-3"
          step={80}
        >
          {partnershipOptions.map(({ Icon, title, text }) => (
            <article
              key={title}
              className="group flex flex-col bg-white p-8 transition-colors hover:bg-ibon-dark lg:p-10"
            >
              <Icon className="text-3xl text-ibon-sky" />
              <h3 className="mt-7 text-xl font-bold tracking-tight text-ibon-dark transition-colors duration-300 group-hover:text-white">
                {title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-text-muted transition-colors duration-300 group-hover:text-white/70">
                {text}
              </p>
            </article>
          ))}

          {/* Volunteer call-out fills the last grid cell */}
          <article className="flex flex-col justify-center bg-ibon-sky p-8 lg:p-10">
            <h3 className="text-xl font-bold tracking-tight text-ibon-dark">Volunteer With Us</h3>
            <p className="mt-3 text-base leading-relaxed text-ibon-dark/80">
              Share your time, skills, and expertise. Professionals, mentors, students, and
              advocates can all help create lasting impact.
            </p>
            <NavLink
              to={`${ROUTES.CONTACT}?interest=Volunteering`}
              className="mt-7 inline-flex w-fit items-center rounded-full bg-ibon-dark px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-ibon-navy"
            >
              Become a Volunteer
            </NavLink>
          </article>
        </RevealGroup>
      </Container>
    </section>
  )
}
